import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import {
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CARS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { StandardTabs } from "../../../../../../shared/components/tabs/StandardTabs"
import { ServiceCenterAdminResourcesRoom } from "./room/ServiceCenterAdminResourcesRoom"
import { ServiceCenterAdminResourcesCars } from "./ServiceCenterAdminResourcesCars"
import { ServiceCenterAdminResourcesMobileAV } from "./ServiceCenterAdminResourcesMobileAV"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { useNavigate } from "react-router"
import { Menu, MenuItem } from "@mui/material"
import { useState } from "react"

export function ServiceCenterAdminResources() {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const { l10n } = useAppLocalization()
    const navigate = useNavigate()
    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)

    const tabs = [
        {
            label: l10n.getString("service-center-admin-organization-resources-rooms-tab"),
            component: <ServiceCenterAdminResourcesRoom />,
        },
        {
            label: l10n.getString("service-center-admin-organization-resources-mobile-av-equipment-tab"),
            component: <ServiceCenterAdminResourcesMobileAV />,
        },
        {
            label: l10n.getString("service-center-admin-organization-resources-cars-tab"),
            component: <ServiceCenterAdminResourcesCars />,
        },
    ]

    const handleCreate = (index: number) => () => {
        const routes = [
            SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE,
            SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE,
            SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CARS_ROUTE,
        ]
        navigate(routes[index])
    }

    return (
        <>
            <LocalizedStrict id="service-center-admin-organization-resources-title" attrs={{ title: true }}>
                <PageHeader
                    title="Resources"
                    rightElement={
                        <>
                            <LocalizedStrict id="service-center-admin-organization-resources-create-button">
                                <StandardButton type="submit" onClick={handleClick}>
                                    Create new
                                </StandardButton>
                            </LocalizedStrict>
                            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                                <LocalizedStrict id="service-center-admin-organization-resources-create-room">
                                    <MenuItem onClick={handleCreate(0)}>Room</MenuItem>
                                </LocalizedStrict>
                                <LocalizedStrict id="service-center-admin-organization-resources-mobile-av-equipment-tab">
                                    <MenuItem onClick={handleCreate(1)}>AV equipment</MenuItem>
                                </LocalizedStrict>
                                <LocalizedStrict id="service-center-admin-organization-resources-create-car">
                                    <MenuItem onClick={handleCreate(2)}>Car</MenuItem>
                                </LocalizedStrict>
                            </Menu>
                        </>
                    }
                    page={Page.SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization">
                            <Breadcrumb>Organization</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-organization-resources">
                            <Breadcrumb>Resources</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <StandardTabs tabs={tabs} />
        </>
    )
}
